export const shortenString = (str, val) => {
  if (str.length > val) {
    return str.substring(0, val) + "..";
  } else {
    return str;
  }
};
